import React from "react";
import Segmented from "./Segmented";

const Step = ({ label, glyph, to, onPick }) => (
  <button
    type="button"
    aria-label={label}
    disabled={!to}
    onClick={() => onPick(to)}
    className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#F26A1F] w-[28px] h-[28px] rounded-[7px] text-[16px] cursor-pointer disabled:cursor-default hover:bg-[#F6F2EF] disabled:hover:bg-transparent"
    style={{ color: to ? "#1f1f1f" : "#cfcfcf" }}
  >
    {glyph}
  </button>
);

/**
 * The selected week (stepper) and what it is compared with.
 *
 * @param {Object} props
 * @param {Object} props.header - buildView().header.
 * @param {(iso: string) => void} props.onSelect - A day in the week to show.
 * @param {(key: string) => void} props.onCompare
 */
const WeekHeader = ({ header: h, onSelect, onCompare }) => (
  <div className="flex items-center gap-[14px] flex-wrap">
    <div className="flex items-center gap-[6px] bg-white border border-[#E8E0D9] rounded-[10px] p-[3px]">
      <Step label="Go to previous week" glyph="‹" to={h.prevSel} onPick={onSelect} />
      <div className="flex flex-col items-center min-w-[120px] leading-[1.2]" aria-live="polite">
        <span className="text-[13px] font-bold">{h.wkRange}</span>
        <span className="text-[11px] text-[#8a8a8a]">{h.wkLabel}</span>
      </div>
      <Step label="Go to next week" glyph="›" to={h.nextSel} onPick={onSelect} />
    </div>
    <div className="flex items-center gap-[8px]">
      <span className="text-[12px] text-[#6b6b6b]">Compare with</span>
      <Segmented options={h.cmpOpts} onPick={onCompare} label="Compare with" />
    </div>
  </div>
);

export default WeekHeader;
